<template>
  <el-card class="user-box">
    <div class="toolbar">
      <el-button type="primary" @click="onAddItem()">
        <i class="fas fa-plus"></i> 新增角色
      </el-button>
    </div>
    <el-table :data="items">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
      />
      <el-table-column prop="Name" label="角色名" width="150" />
      <el-table-column prop="Perms_names" label="权限名称">
        <template slot-scope="{ row }">
          <el-tag
            v-for="(p, index) in row.Perms_names"
            :key="index"
            class="mr-5 mb-5"
            >{{ p }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column width="100" label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click.stop="onEditItem(scope.row)"
            title="编辑"
          >
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <el-button
            type="danger"
            @click.stop="onDeleteItem(scope.row)"
            title="删除"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="paginator pull-right mt-10 mb-10">
      <el-pagination
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
        @current-change="onChangePage"
      />
    </div>
    <item-form
      v-model="item"
      :visible.sync="editing"
      :perms-list="permsList"
      @form:saved="getItemList"
    />
  </el-card>
</template>

<script>
import ItemForm from "./index--form.vue";

export default {
  components: {
    ItemForm,
  },
  data() {
    return {
      items: [],
      item: this.getEmptyItem(),
      permsList: [],
      querier: {},
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      loading: false,
      editing: false,
    };
  },
  created() {
    this.getPermsList();
  },
  methods: {
    getPermsList() {
      this.$axios
        .get("perm", { params: { with: ["Perms"] } })
        .then((response) => {
          this.permsList = response.data.data;
          this.getItemList();
        });
    },
    getItemList() {
      this.loading = true;
      const params = {
        ...this.querier,
      };
      this.$axios.get("role", { params }).then(
        (response) => {
          const list = response.data.data;
          list.map((ele) => {
            const obj = ele;
            obj.Perms_names = [];
            if (obj.Perms) {
              obj.Perms.forEach((ps) => {
                this.permsList.forEach((pl) => {
                  if (ps.Obj === pl.Path.Obj) {
                    var name = pl.Desc.Group + "-" + pl.Desc.Model;
                    if (obj.Perms_names.indexOf(name) === -1) {
                      obj.Perms_names.push(name);
                    }
                  }
                });
              });
            }
            return obj;
          });
          this.items = list;
          this.pager.size = response.data.size;
          this.pager.page = response.data.page;
          this.pager.total = response.data.total;
          if (this.pager.page > response.data.last) {
            this.querier.page = response.data.last;
            this.getItemList();
          }
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    },
    getEmptyItem() {
      return {
        Name: "",
        Perms: [],
        Remark: "",
        RoleGroupID: 1,
      };
    },
    onSubmitQuery() {
      this.querier = {
        ...this.pager,
      };
      if (this.pager.page !== 1) {
        this.pager.page = 1;
      }
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.querier.page = page;
      this.getItemList();
    },
    onAddItem() {
      this.item = this.getEmptyItem();
      this.editing = true;
    },
    onEditItem(row) {
      this.item = row;
      this.editing = true;
    },
    onDeleteItem(row) {
      this.$confirm("确定要删除吗？", "提示")
        .then(() => this.$axios.delete(`role/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success("成功删除");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
      this.getItemList();
    },
  },
};
</script>

<style lang="scss">
.user-box {
  .el-input__inner {
    height: 31px !important;
    line-height: 31px;
  }
  .el-input__icon {
    height: 31px !important;
    line-height: 31px;
  }
}
</style>
